import React from 'react';
import { Job, JobStatus } from '../../job-summary/Interfaces';
import { getJobBadgeColor } from '../utils/statusHelpers';

export interface JobStatusDropdownProps {
  job: Job;
  isJobActive: boolean;
  currentSessionMinutes: number;
  formatTime: (minutes: number) => string;
  show: boolean;
  onTriggerClick: (e: React.MouseEvent) => void;
  onStatusChange: (status: JobStatus) => void;
}

const JobStatusDropdown: React.FC<JobStatusDropdownProps> = ({
  job,
  isJobActive,
  currentSessionMinutes,
  formatTime,
  show,
  onTriggerClick,
  onStatusChange,
}) => {
  const badgeColor = getJobBadgeColor(job, isJobActive);

  return (
    <div className="position-relative" onClick={(e) => e.stopPropagation()}>
      <span
        role="button"
        tabIndex={0}
        className="btn btn-sm fw-bold d-flex align-items-center"
        onClick={onTriggerClick}
        title={`Status: ${job.status}`}
        style={{ 
          fontSize: '0.75rem', 
          borderRadius: '0.425rem', 
          padding: '4px 8px',
          backgroundColor: badgeColor,
          color: 'white'
        }}
      >
        <span className="me-1">
          {job.status}
        </span>
        <i className="fas fa-chevron-down fs-9"></i>
      </span>
      
      {show && (
        <div className="dropdown-menu show position-absolute" style={{ 
          top: '100%', left: '0', zIndex: 9999, minWidth: '180px'
        }}>
          <button className="dropdown-item" onClick={() => onStatusChange('Open')}>Open</button>
          <button className="dropdown-item" onClick={() => onStatusChange('Pending')}>Pending</button>
          <button className="dropdown-item" onClick={() => onStatusChange('Awaiting Client Response')}>Awaiting Client Response</button>
          <button className="dropdown-item" onClick={() => onStatusChange('Overdue')}>Overdue</button>
          <button className="dropdown-item" onClick={() => onStatusChange('Closed')}>Closed</button>
          <button className="dropdown-item" onClick={() => onStatusChange('Cancelled')}>Cancelled</button>
          <button className="dropdown-item" onClick={() => onStatusChange('Archived')}>Archived</button>
        </div>
      )}
    </div>
  );
};

export default JobStatusDropdown;
